import { BrandLoader } from './BrandLoader'
import { cn } from '@/lib/utils'
import { useMessages } from '@/i18n'
import { messages } from './messages'

type SpinnerSize = 'sm' | 'md' | 'lg'

interface SpinnerProps {
  size?: SpinnerSize
  label?: string
  className?: string
  /** Строго по центру экрана (гейты маршрутов) */
  fullScreen?: boolean
  /** Строго по центру области контента (окно минус меню слева, `--content-left` из
   *  `AppLayout`) — для загрузки страницы внутри раскладки. Не от контейнера
   *  страницы: его отступы уводили крутилку вверх и вбок. */
  fullPage?: boolean
}

const SIZES: Record<SpinnerSize, string> = {
  sm: 'size-8',
  md: 'size-16',
  lg: 'size-20',
}

export const Spinner = ({ size = 'md', label, className, fullScreen, fullPage }: SpinnerProps) => {
  const m = useMessages(messages)
  const content = (
    <div
      role="status"
      aria-label={label ?? m.loading}
      className={cn('flex flex-col items-center gap-3 text-muted-foreground', className)}
    >
      <BrandLoader className={SIZES[size]} />
      {label ? <span className="text-sm">{label}</span> : null}
    </div>
  )
  if (fullScreen || fullPage) {
    return (
      <div className="pointer-events-none fixed inset-y-0 right-0 left-[var(--content-left,0px)] z-10 flex items-center justify-center">
        {content}
      </div>
    )
  }
  return content
}
